import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface UnsupportedBannerProps {
  countryName: string | null;
}

const UnsupportedBanner: React.FC<UnsupportedBannerProps> = ({ countryName }) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        background: 'linear-gradient(90deg, #475569 0%, #64748b 100%)',
        color: '#fff',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        fontSize: '0.875rem',
        lineHeight: 1.5,
        zIndex: 1040,
        boxShadow: '0 2px 8px rgba(71, 85, 105, 0.3)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, flex: 1 }}>
        <span style={{ fontSize: '1.1rem', flexShrink: 0, marginTop: 1 }}>ℹ️</span>
        <span>
          <strong>
            {t('geo.unsupported_title', { defaultValue: 'Region Not Supported' })}
          </strong>
          {' — '}
          {t('geo.unsupported_banner_body', {
            country: countryName ?? t('geo.your_region', { defaultValue: 'your region' }),
            defaultValue:
              'Our services are currently not available in {{country}}.',
          })}
          {' '}
          <Link to="/global-availability" style={{ color: '#fff', textDecoration: 'underline' }}>
            View global availability
          </Link>
        </span>
      </div>
    </div>
  );
};

export default UnsupportedBanner;
